import { render, staticRenderFns } from "./RatingUserAnswer.vue?vue&type=template&id=2f94c212&scoped=true&lang=html"
import script from "./RatingUserAnswer.vue?vue&type=script&lang=js"
export * from "./RatingUserAnswer.vue?vue&type=script&lang=js"
import style0 from "./RatingUserAnswer.vue?vue&type=style&index=0&id=2f94c212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f94c212",
  null
  
)

export default component.exports